import {
  HorizontalBar
} from "vue-chartjs";

export default {
  name: "Home",
  extends: HorizontalBar,
  props: ["data"],
  data: (vm) => ({
    // weekdays: ["Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado", "Domingo"],
    gross_value: [0, 0, 0, 0, 0, 0, 0],
    awarded: [0, 0, 0, 0, 0, 0, 0],
    chartdata: {
      labels: [],
      datasets: [{
          // label: "R$ Bruto",
          data: [],
          pointBackgroundColor: "white",
          borderWidth: 1,
          pointBorderColor: "white",
          backgroundColor: vm.$vuetify.theme.themes.dark.primary
        },
        {
          // label: "R$ Prêmios",
          data: [],
          pointBackgroundColor: "white",
          borderWidth: 1,
          pointBorderColor: "white",
          backgroundColor: 'rgba(0,250,154, 1)',
        },
      ],
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        xAxes: [{
          ticks: {
            min: 0,
            max: 0,
            stepSize: 10,
          }
        }]
      }
    },

    gradient: ''
  }),

  computed: {
    weekdays() {
      return [this.$t('monday'), this.$t('tuesday'), this.$t('wednesday'), this.$t('thursday'), this.$t('friday'), this.$t('saturday'), this.$t('sunday')]
    },
  },
  mounted() {
    this.chartdata.datasets[0].label = `${this.$t('labelCurrency')} ${this.$t('gross')}`;
    this.chartdata.datasets[1].label = `${this.$t('labelCurrency')} ${this.$t('awards')}`;
  },

  watch: {
    data(val) {
      val && this.buildChart()
    },
  },

  methods: {
    async buildChart() {
      this.data.dados && this.data.dados.forEach((item) => {
        let indexDay = new Date(item.date_bet).getDay();
        this.awarded[indexDay] = item.awarded;
        this.gross_value[indexDay] = item.gross_value;
      });

      this.chartdata.datasets[0].data = this.gross_value
      this.chartdata.datasets[1].data = this.awarded

      this.chartdata.labels = this.weekdays
      this.options.scales.xAxes[0].ticks.max = await this.max;
      this.renderChart(this.chartdata, this.options);
    },
  },
};